export default __webpack_public_path__ + "static/media/recharge.653928d9.svg";